'use client'

import JoinWaitlist from '@/components/JoinWaitlist'
import ColorScheme from '@/components/colorScheme'
import type { ColorScheme as ColorSchemeType } from '@/sanity.types'

type Props = {
  body: string
  colorScheme?: ColorSchemeType
  bodyClassName?: string
  underlinedPrefix?: string
  variant?: 'themed' | 'vanilla'
}

const layoutClass =
  'mt-6 flex flex-col gap-4 rounded p-4 md:flex-row md:items-center md:gap-5 md:p-5'

const sunUnderlineClass =
  'font-semibold underline decoration-sun decoration-[3px] underline-offset-[0.2em]'

function renderCtaBody(body: string, underlinedPrefix?: string) {
  if (!underlinedPrefix || !body.startsWith(underlinedPrefix)) {
    return body
  }

  return (
    <>
      <span className={sunUnderlineClass}>{underlinedPrefix}</span>
      {body.slice(underlinedPrefix.length)}
    </>
  )
}

export default function PlaybookCtaBlock({
  body,
  colorScheme = 'grape',
  bodyClassName = 'text-sm leading-[1.4]',
  underlinedPrefix,
  variant = 'themed',
}: Props) {
  const content = (
    <>
      <p className={`min-w-0 md:flex-1 ${bodyClassName}`}>
        {renderCtaBody(body, underlinedPrefix)}
      </p>
      <div className="w-full shrink-0 md:w-auto">
        <JoinWaitlist
          asModal
          embedded
          colorScheme={colorScheme}
          heightInRem={2.625}
          modifier="rounded w-full md:w-auto md:max-w-none!"
        />
      </div>
    </>
  )

  if (variant === 'vanilla') {
    return (
      <aside className={`${layoutClass} bg-greyscale-vanilla text-soft-black`}>
        {content}
      </aside>
    )
  }

  return (
    <ColorScheme colorScheme={colorScheme}>
      <aside
        className={`${layoutClass} bg-(--color-background) text-(--color-foreground)`}
      >
        {content}
      </aside>
    </ColorScheme>
  )
}
